import React from "react";
import { Col, Row, Tabs } from "antd";
import AdminSubmissions from "@Components/assessment/AdminSubmissions";
import AdminUsers from "@Components/assessment/AdminUsers";
import NewAssessment from "@Components/assessment/NewAssessment";
import { hasCapabilityContext, useSearchParams } from "@Utils";
import { IAssessmentPageProps } from "@Components/assessment/types";
import PageHelmet from "@Components/shared/PageHelmet";
import { getTutorialTip } from "@Components/assessment/helpers";
import { GroupContext } from "@Constants";
import GuidanceDrawer from "@Components/shared/GuidanceDrawer";

const AssessmentAdmin: React.FC<IAssessmentPageProps> = ({ assessmentId, hasSubmissions, tab }) => {
    const [, setSearchParams] = useSearchParams();
    const handleTabChange = (newTab: string) => setSearchParams({ assessment: assessmentId, tab: newTab });

    const canUpdate = hasCapabilityContext("Assessment/Update", GroupContext);
    const canViewCurrentPast = hasCapabilityContext("Assessment/GetInstances", GroupContext);

    return (
        <article className="assessment-page assessments-section">
            <PageHelmet name={"Assessment"} />
            <section>
                <Row>
                    <Col xs={24}>
                        <Tabs
                            activeKey={tab}
                            className={"newUI-raised"}
                            centered
                            onChange={handleTabChange}
                            type="card"
                        >
                            {canViewCurrentPast && (
                                <>
                                    <Tabs.TabPane tab="Users" key="users" className={"tab-flex"}>
                                        <div className="guidance-container">
                                            <GuidanceDrawer text={getTutorialTip("users")} />
                                        </div>
                                        <AdminUsers tab="users" />
                                    </Tabs.TabPane>
                                    <Tabs.TabPane disabled={!hasSubmissions} tab="Submissions" key="submissions">
                                        <div className="guidance-container">
                                            <GuidanceDrawer text={getTutorialTip("submissions")} />
                                        </div>
                                        <AdminSubmissions tab="submissions" />
                                    </Tabs.TabPane>
                                </>
                            )}

                            {canUpdate && (
                                <>
                                    <Tabs.TabPane tab="Edit" key="edit">
                                        <div className="guidance-container">
                                            <GuidanceDrawer text={getTutorialTip("edit")} />
                                        </div>
                                        <NewAssessment tab="edit" />
                                    </Tabs.TabPane>
                                </>
                            )}
                        </Tabs>
                    </Col>
                </Row>
            </section>
        </article>
    );
};

export default AssessmentAdmin;
